export const SLIDER = 'Slider';
export const NEW_PRODUCTS = 'NewProducts';
export const CATALOG_PRODUCT_LIST = 'CatalogProductList';
export const SALE_COUNT_DOWN = 'SaleCountDown';
